import React, { useState } from "react";
import { TableContainer, Avatar } from "@material-ui/core";
import { useSnackbar } from "react-simple-snackbar";
import { ApiService, ImgUrl } from "../services";
import { Edit, Delete } from "@material-ui/icons";
import {
  Table,
  TableBody,
  TableRow,
  TableRowData,
  TableHead,
  TableHeader,
} from "./../styledComponents/tableStyle";
import GButton from "../gComponents/gButton";
import GConfirmDialog from "../gComponents/gConfirmDialog";
import StaffForm from "../forms/staffForm";
import useDataFctory from "../useDataFactory";
import GText from "../gComponents/gText";
import Modal from "react-modal";
import AssignRoleForm from "../forms/assignRoleForm";

const columns = [
  { id: "first_name", label: "Name", minWidth: 130 },
  { id: "photo", label: "Photo", minWidth: 50, type: "image" },
  { id: "email", label: "Email", minWidth: 150 },
  { id: "role", label: "Role", minWidth: 150, align: "center" },
  { id: "created_at_formatted", label: "Created", minWidth: 150 },
  { id: "actions", label: "Actions", minWidth: 60, align: "center" },
];

export default function StaffMembers(props) {
  const [openSnackbar] = useSnackbar();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedStaffData, setSelectedStaffData] = useState({});
  const [selectedStaffId, setSelectedStaffId] = useState("");
  const [isEmpty, setIsEmpty] = useState(true);
  const [sFormVisible, setSFormVisible] = useState(false);
  const [assignRoleVisible, setAssignRoleVisible] = useState(false);
  const {
    loading,
    data: staffData,
    Placeholder,
    TableShimmer,
    refreshData,
  } = useDataFctory("staff", false);

  const deleteStaff = () => {
    var hitUrl = "staff/" + selectedStaffId;
    ApiService({ method: "DELETE", route: hitUrl })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          let selectedIndex = staffData.findIndex(
            (p) => p.id == selectedStaffId
          );
          if (selectedIndex > -1) {
            staffData.splice(selectedIndex, 1);
          }
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="mainInnerView">
      <GButton
        variant="condensed"
        children="Create Staff"
        onClick={() => {
          setIsEmpty(true);
          setSelectedStaffData({});
          setSFormVisible(true);
        }}
        style={{ float: "right", marginTop: "5px" }}
      />

      <GText g2 bold text={"Staff Members"} style={{ marginBottom: "15px" }} />

      <div className="listPaper">
        {loading === true ? (
          <TableShimmer />
        ) : (
          <TableContainer>
            {staffData && staffData.length === 0 ? (
              <Placeholder />
            ) : (
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableHeader
                        key={column.id}
                        style={{
                          minWidth: column.minWidth,
                          textAlign: column.align,
                        }}
                      >
                        {column.label}
                      </TableHeader>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {staffData.map((c) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={c.id}>
                        <TableRowData
                          style={{
                            BorderBottom: "1px solid #f4f5f9",
                          }}
                        >
                          {c.first_name} {c.last_name}
                        </TableRowData>
                        <TableRowData>
                          <Avatar
                            alt={c.first_name}
                            src={ImgUrl("user") + "/" + c.thumb_photo}
                          />
                        </TableRowData>
                        <TableRowData>{c.email}</TableRowData>
                        <TableRowData
                          style={{
                            textAlign: "center",
                          }}
                        >
                          {c.role?.name || "-"}
                        </TableRowData>
                        <TableRowData>{c.created}</TableRowData>
                        <TableRowData
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <GButton
                            variant="linkable"
                            onClick={(e) => {
                              setIsEmpty(false);
                              setSelectedStaffData(c);
                              setSFormVisible(true);
                            }}
                          >
                            <Edit fontSize="small" />
                          </GButton>
                          <GButton
                            variant="linkable"
                            onClick={(e) => {
                              setSelectedStaffId(c.id);
                              setDialogOpen(true);
                            }}
                          >
                            <Delete fontSize="small" />
                          </GButton>
                          <GButton
                            variant="condensed"
                            onClick={(e) => {
                              setSelectedStaffData(c);
                              setAssignRoleVisible(true);
                            }}
                            style={{ padding: "0.65rem", width: "120px" }}
                          >
                            {c.role?.id ? "Re-Assign" : "Assign"} Role
                          </GButton>
                        </TableRowData>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </TableContainer>
        )}
      </div>

      {dialogOpen === true ? (
        <GConfirmDialog
          open={dialogOpen}
          title="Delete Staff"
          text="Are you sure you want to delete this staff?"
          handleClose={() => setDialogOpen(false)}
          onConfirmClose={() => {
            setDialogOpen(false);
            deleteStaff();
          }}
        ></GConfirmDialog>
      ) : (
        ""
      )}

      <Modal
        isOpen={sFormVisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setSFormVisible(false)}
        style={{
          content: {
            width: "400px",
          },
        }}
        contentLabel="Staff Member Form Modal"
      >
        <StaffForm
          sFormVisible={sFormVisible}
          setSFormVisible={setSFormVisible}
          isEmpty={isEmpty}
          data={selectedStaffData}
          onSubmit={(data) => {
            let selectedIndex = staffData.findIndex((p) => p.id == data.id);
            if (selectedIndex > -1) {
              staffData[selectedIndex] = { ...data };
            } else {
              staffData.push(data);
            }
          }}
        />
      </Modal>

      <Modal
        isOpen={assignRoleVisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setAssignRoleVisible(false)}
        style={{
          content: {
            width: "400px",
          },
        }}
        contentLabel="Assign Role Form Modal"
      >
        <AssignRoleForm
          assignRoleVisible={assignRoleVisible}
          setAssignRoleVisible={setAssignRoleVisible}
          staffData={selectedStaffData}
          type="admin"
          onSubmit={() => refreshData()}
        />
      </Modal>
    </div>
  );
}
